import { Divider } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Fragment, useMemo, useState } from "react";
import { Notification } from "src/utils/Notification";

import AuthorizationModal, {
  type UserSelectItem,
} from "../../../../generator/_Modals/AuthorizationModal/AuthorizationModal";
import { useIsOnline, usePostApi } from "../../../../hooks";
import { useSelector } from "../../../../redux/hooks";
import { Flex } from "../../../../styled";
import { getUserId } from "../../../../utils";
import { Button } from "../../Button/Button";
import { type IUser } from "../UserList.types";
import { refreshLogoutTimer } from "src/generator/utils/refreshLogoutTimer";
interface Props {
  setShowRotationChange: (value: boolean) => void;
  showRotationChange: boolean;
  setChangedUsers: (value: IUser[]) => void;
  changedUsers: IUser[];
  refetch: () => Promise<void>;
}
const SetMultipleRotation = ({
  setShowRotationChange,
  showRotationChange,
  setChangedUsers,
  changedUsers,
  refetch,
}: Props) => {
  const isOnline = useIsOnline();
  const [opened, { open, close }] = useDisclosure();
  const { post } = usePostApi();
  const { fullName, usertype } = useSelector(state => state.permsSlice);
  const [isLoading, setIsLoading] = useState(false);
  const toggleShowRotationChange = () => {
    setShowRotationChange(!showRotationChange);
    if (showRotationChange) setChangedUsers([]);
  };

  const handleSave = async (params: any) => {
    const mapUsers = (active: boolean) =>
      changedUsers
        .filter(u => (active ? u.newActiveValue : !u.newActiveValue))
        .map(u => u.userid);

    setIsLoading(true);
    await post({
      request: "update-users-status",
      body: {
        params: {
          ...(params.pass
            ? { pass: params.pass }
            : params.pin
              ? { pin: params.pin }
              : {}),
          inactive: mapUsers(false),
          active: mapUsers(true),
        },
      },
    });
    await refetch();
    setIsLoading(false);
    close();
    setChangedUsers([]);
    setShowRotationChange(false);
    Notification("Success", "Users were updated", "green");
    refreshLogoutTimer();
  };

  const handleOpen = () => {
    void open();
  };

  const authUsers: UserSelectItem[] = useMemo(
    () => [
      {
        label: fullName,
        value: getUserId(),
        usertype,
      },
    ],
    [usertype, fullName],
  );

  if (!isOnline) return null;
  return (
    <Fragment>
      <Flex gap={10}>
        <Divider orientation="vertical" size="sm" />
        <Button
          onClick={toggleShowRotationChange}
          color={(showRotationChange && "red") as string}>
          {!showRotationChange ? "Assign Rotation to Users" : "Cancel"}
        </Button>
        {showRotationChange && <Button onClick={handleOpen}>Save</Button>}
      </Flex>
      <AuthorizationModal
        opened={opened}
        close={close}
        onSubmit={handleSave}
        loading={isLoading}
        users={authUsers}
        isEntry={false}
      />
    </Fragment>
  );
};
export default SetMultipleRotation;
